module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p11"
    }
  }), _vm._v(" DANGEROUS CURVES: DRINKS")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('img', {
    staticClass: "art",
    attrs: {
      "alt": "[Image]",
      "id": "fig_BikerBillysHogWildOnAHarleyCookbook-28",
      "src": "images/BikerBillysHogWildOnAHarleyCookbook-28.jpg",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("One of the sweetest parts of riding my Harley is guiding it through curvy roads. What a rush it is to pilot a big twin around a tight curve on a country road and find out what lies around the bend. It's like dancing, the music of the motor and the rhythm of leaning in and out of turns. The only thing more exciting is to ride those same roads on my Buell. Heck, I could ride curvy roads all day long on the Buell, since that is where those bikes shine the most. But I digress, back to food and, in this case, drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("When I plan a trip, I will often look for roads on the map that snake across the countryside and provide the most curves per mile. While the place I am headed to is a big part of any trip, the adventure is always in the journey there. Just like a nice meal, where the dessert is the sweet ending but the real excitement comes in getting there. That excitement should start with the first thing you serve.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('a', {
    attrs: {
      "id": "p12"
    }
  }), _vm._v(" When I plan a dinner gathering, I like to start with something that will set the tone for the meal. Like any fine restaurant experience, the meals at my house often begin with a cocktail and some conversation. You know that after a long ride we like to do some \"bench racing\"—there's nothing like telling tall tales with your riding buddies to get an appetite revved-up.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("After the meal is done, it is time to kick back with a cup of Joe or some other after-dinner beverage and recap the day's ride or plan the next big road trip. It is during times like these, hanging with my riding buddies, sharing drinks and food, that it becomes so clear that we are all part of a big Harley riding family.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Just like you care about your family, I care about my Harley riding family. I feel it is important to offer along with these recipes a few words of family wisdom— "), _c('em', [_vm._v("don't drink and ride.")]), _vm._v(" With that said, enjoy these recipes and the camaraderie of your friends.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Biker Patriot Uncle John's Nasty Black Coffee")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/c008#p13"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Jason's Burning Marys")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c009#p14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Josh Placa's Grandma's Wild Eggnog")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Lynn Dwight's Brandy or Rum Slushy")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c011#p16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_vm._v("Michael Pagan's High-Octane Martini")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/c012#p17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba6fb23a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c0002.vue
// module id = 102
// module chunks = 0